import React, { useState, useEffect, useCallback } from "react";
import { CardMedia, Box } from "@mui/material";

interface ImageCarouselProps {
  photos: string[]; // Array of image URLs
  altText: string;
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({ photos, altText }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentIndexLoaded, setCurrentIndexLoaded] = useState(0);

  const goToNextImage = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % photos.length);
  }, [photos.length]);

  // Update the useEffect hook
  useEffect(() => {
    const interval = setInterval(goToNextImage, 5000);
    return () => clearInterval(interval);
  }, [goToNextImage]);

  const handleImageLoad = () => {
    setCurrentIndexLoaded(currentIndex);
  };

  return (
    <Box sx={{ position: "relative", width: "100%", textAlign: "center" }}>
      {/* Display the current image */}
      <CardMedia
        component="img"
        image={photos[currentIndex]}
        alt={altText}
        onLoad={handleImageLoad} // Call the handler when the image is loaded
        sx={{
          width: "100%",
          height: "auto",
          minHeight: "350px",
          objectFit: "cover",
          transition: "opacity 0.5s ease", // Smooth transition after image loads
        }}
      />

      {/* Image indicators (lines) */}
      <Box
        sx={{
          position: "absolute",
          top: 10,
          left: 0,
          right: 0,
          display: "flex",
          justifyContent: "center",
          width: "100%",
          padding: "0 20px",
        }}
      >
        {photos.map((_, index) => (
          <Box
            key={index}
            sx={{
              width: "100%",
              maxWidth: "100px",
              height: "4px",
              backgroundColor: index === currentIndexLoaded ? "#666666" : "white",
              mx: 0.5,
              borderRadius: "2px",
              transition: "width 0.3s ease",
              marginTop: "15px",
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default ImageCarousel;
